import axios from 'axios'

const state = {
    recipients: []
}

const getters = {
    GetRecipients: state => state.recipients
}

const mutations = {
    SetRecipients(state, recipients) {
        state.recipients = recipients || []
    },
    resetRecipients(state) {
        state.recipients = []
    }
}

const actions = {
    async GetRecipients({ commit }) {
        return await axios.get("/api/user/recipients/array").then(res => res.data)
    },
}

export default {
    state,
    getters,
    mutations,
    actions
}
